import PropTypes from "prop-types";
import Subscription from "@/features/subscription/Subscription";

const SubscriptionDetails = ({
  setActiveTab,
  selectedPlan,
  setSelectedPlan,
}) => {
  return (
    <div className="mt-4">
      <h2 className="mb-2 text-bold">Subscription Details</h2>
      <p className="mb-4 text-regular text-lighterGrey">
        Manage your subscription details here.
      </p>

      <Subscription
        showTopSection={false}
        showFooter={false}
        onProceed={() => {
          setActiveTab("payment");
        }}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />
    </div>
  );
};

SubscriptionDetails.propTypes = {
  setActiveTab: PropTypes.func,
  selectedPlan: PropTypes.string,
  setSelectedPlan: PropTypes.func,
};

export default SubscriptionDetails;
